<template>
  <svg
    width="136"
    height="140"
    viewBox="0 0 136 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M74.7493 65.0449H68.4366V69.8811H61.3662V65.0449H44.7132L19.7617 85.1123V111.577V134.532C19.7617 137.553 22.2094 140.001 25.2303 140.001H115.996C119.017 140.001 121.465 137.553 121.465 134.532V65.0449H74.7493Z"
      fill="#E4E7F2"
    />
    <path
      d="M61.5853 65.0449H44.7132L19.7617 85.1123V111.577C20.6657 111.856 21.6123 112.003 22.5691 112.003H22.5694C25.0645 112.003 27.4262 111.048 29.2344 109.298L61.585 77.8439V65.0449H61.5853Z"
      fill="#D4D8E4"
    />
    <path
      d="M31.9568 134.532V111.577V85.1123L56.9083 65.0449H44.7132L19.7617 85.1123V111.577V134.532C19.7617 137.553 22.2094 140.001 25.2303 140.001H37.4254C34.4046 140.001 31.9568 137.553 31.9568 134.532Z"
      fill="#D4D8E4"
    />
    <path
      d="M104.25 23.0261L92.9968 11.4509C91.5457 9.95747 89.1545 9.92359 87.661 11.3775L43.3722 54.4377L44.3312 55.3967L41.3751 58.3529L40.3745 57.3523L10.6072 86.2942C9.11372 87.7453 9.07984 90.1337 10.5338 91.63L21.7871 103.202C22.2049 103.634 22.8966 103.643 23.3286 103.225L35.4853 91.4042L61.2942 66.3109H60.2547V66.1729V64.3336V64.3H62.6383V64.3336H62.6513V64.9917L92.0708 36.3883L104.228 24.5676C104.66 24.1469 104.671 23.458 104.25 23.0261Z"
      fill="#E4E7F2"
    />
    <path
      d="M37.256 35.3379L30.4656 41.3736L27.3358 38.2111V40.1478H21.1789V38.9124L3.35742 52.9194L16.4907 66.4273C20.3966 70.4447 26.82 70.5351 30.8374 66.6292L43.3857 54.4287L49.8661 47.9483L37.256 35.3379Z"
      fill="#F7F8FF"
    />
    <path
      d="M23.2065 59.9891L10.7127 47.1387L3.35742 52.9198L16.4907 66.4277C20.3966 70.4451 26.82 70.5355 30.8374 66.6296L36.6913 60.9377C32.664 64.0638 26.8442 63.7304 23.2065 59.9891Z"
      fill="#D5DAEB"
    />
    <path d="M61.3652 65.043H79.8598V139.999H61.3652V65.043Z" fill="#F7F8FF" />
    <path
      d="M61.3633 78.0571L74.7461 65.0449H61.3633V78.0571Z"
      fill="#D5DAEB"
    />
    <path
      d="M26.6738 89.5239L19.7552 82.4094C18.5842 81.2042 18.3801 79.4205 19.1248 78.0137L10.6072 86.295C9.11372 87.7461 9.07984 90.1346 10.5338 91.6309L21.7871 103.203C22.2049 103.635 22.8966 103.644 23.3286 103.226L31.8806 94.9103L26.6738 89.5239Z"
      fill="#D4D8E4"
    />
    <path
      d="M67.5102 16.8282L54.3766 3.32031L37.3654 19.2935V24.8094L43.042 30.8683L34.8965 37.5096L47.761 50.3741L54.7597 43.3754L67.3083 31.1749C71.3257 27.269 71.4161 20.8457 67.5102 16.8282Z"
      fill="#F7F8FF"
    />
    <path
      d="M48.5023 38.1156C47.9504 38.1156 47.399 37.9014 46.984 37.4742C46.169 36.6357 46.1876 35.2952 47.0261 34.4802L53.0164 28.6559C53.8549 27.8408 55.1953 27.8595 56.0104 28.698C56.8254 29.5365 56.8068 30.8769 55.9683 31.692L49.978 37.5163C49.5667 37.9166 49.0345 38.1156 48.5023 38.1156Z"
      fill="#D5DAEB"
    />
    <path
      d="M26.9542 37.7687L30.1249 41.0403L17.584 53.2343C13.5665 57.1416 7.14375 57.0513 3.23644 53.0338C1.31948 51.0632 0.365234 48.5111 0.365234 45.9617C0.365234 43.3164 1.39006 40.6767 3.43688 38.6863L4.7045 37.4554C10.9353 31.3968 20.8984 31.5379 26.9542 37.7687Z"
      fill="#E4E7F2"
    />
    <path
      d="M54.625 3.07165C58.5295 7.08907 58.4392 13.5119 54.4217 17.4192L41.8726 29.6183L38.6965 26.3518C32.6407 20.121 32.779 10.1607 39.0099 4.10212L40.2775 2.8712C42.2481 0.954244 44.8002 0 47.3496 0C49.9949 0 52.6346 1.02482 54.625 3.07165Z"
      fill="#E4E7F2"
    />
    <path
      d="M30.3324 55.7817C29.7805 55.7817 29.2291 55.5674 28.8141 55.1402C27.999 54.3017 28.0177 52.9613 28.8562 52.1462L34.8464 46.3219C35.6849 45.5069 37.0254 45.5255 37.8405 46.364C38.6555 47.2025 38.6369 48.5429 37.7984 49.358L31.8081 55.1823C31.3968 55.5823 30.8643 55.7817 30.3324 55.7817Z"
      fill="#D5DAEB"
    />
    <path
      d="M40.377 57.3535L57.8866 40.3322L72.5278 55.3936L55.0182 72.4149L40.377 57.3535Z"
      fill="#F7F8FF"
    />
    <path
      d="M102 45.3675C100.831 45.3675 99.8828 44.4194 99.8828 43.2501V41.0705C99.8828 39.9012 100.831 38.9531 102 38.9531C103.17 38.9531 104.118 39.9012 104.118 41.0705V43.2501C104.118 44.4194 103.17 45.3675 102 45.3675Z"
      fill="#D4D8E4"
    />
    <path
      d="M109.94 51.1977H107.76C106.59 51.1977 105.643 50.2497 105.643 49.0803C105.643 47.9109 106.59 46.9629 107.76 46.9629H109.94C111.109 46.9629 112.057 47.9109 112.057 49.0803C112.057 50.2497 111.109 51.1977 109.94 51.1977Z"
      fill="#D4D8E4"
    />
    <path
      d="M101.932 59.137C100.762 59.137 99.8145 58.189 99.8145 57.0196V54.8401C99.8145 53.6707 100.762 52.7227 101.932 52.7227C103.102 52.7227 104.049 53.6707 104.049 54.8401V57.0196C104.049 58.189 103.102 59.137 101.932 59.137Z"
      fill="#D4D8E4"
    />
    <path
      d="M96.1702 51.1254H93.9904C92.8208 51.1254 91.873 50.1774 91.873 49.008C91.873 47.8387 92.8208 46.8906 93.9904 46.8906H96.1702C97.3399 46.8906 98.2876 47.8387 98.2876 49.008C98.2876 50.1774 97.3399 51.1254 96.1702 51.1254Z"
      fill="#D4D8E4"
    />
    <path
      d="M126.559 18.8879C124.93 17.8376 123.643 16.5793 122.7 15.1129C122.137 14.2394 120.851 14.2282 120.278 15.094C119.299 16.5694 117.996 17.845 116.359 18.9155C115.465 19.5002 115.485 20.8011 116.386 21.3751C117.911 22.3466 119.158 23.6447 120.175 25.2138C120.763 26.1212 122.093 26.052 122.648 25.1246C123.591 23.5501 124.894 22.3226 126.494 21.3836C127.441 20.828 127.481 19.483 126.559 18.8879Z"
      fill="#D5DAEB"
    />
    <path
      d="M134.073 41.0653L123.331 40.0452C122.173 39.9351 121.637 38.5501 122.42 37.6893L129.697 29.6906C130.232 29.1022 131.153 29.0666 131.722 29.6225C134.535 32.3695 135.804 35.7523 135.618 39.7344C135.581 40.5362 134.872 41.1412 134.073 41.0653Z"
      fill="#DCE0ED"
    />
    <path
      d="M129.462 60.5989L122.117 52.9005C121.325 52.0702 121.821 50.6922 122.96 50.5567L133.549 49.297C134.328 49.2044 135.037 49.773 135.102 50.5545C135.423 54.418 134.184 57.7582 131.473 60.6054C130.927 61.1785 130.008 61.1714 129.462 60.5989Z"
      fill="#DCE0ED"
    />
    <path
      d="M50.8723 47.1467L47.3997 50.523C44.9955 52.8606 41.1514 52.8067 38.8138 50.4022L31.238 42.6104C28.9004 40.2061 28.9543 36.3621 31.3589 34.0245L34.8314 30.6482C37.2356 28.3106 41.0797 28.3645 43.4173 30.769L50.9931 38.5608C53.3305 40.965 53.2765 44.8091 50.8723 47.1467Z"
      fill="#E4E7F2"
    />
    <path
      d="M44.3294 44.8876L36.7536 37.0958C34.8256 35.1128 34.5289 32.1521 35.8316 29.8633C35.4787 30.0858 35.1424 30.3463 34.8313 30.649L31.3587 34.0253C28.9545 36.3629 28.9003 40.207 31.2379 42.6112L38.8137 50.403C41.1513 52.8072 44.9954 52.8614 47.3996 50.5238L50.8722 47.1475C51.2934 46.7379 51.6381 46.2802 51.9148 45.7941C49.5408 47.2907 46.3646 46.9807 44.3294 44.8876Z"
      fill="#D4D8E4"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
